<template>
  <Page class="phrases">
    <template #topbar>
      <Topbar/>
    </template>
    <template #contentbar>
      <Contentbar>
        <template #left>
          <BButton
            @click="phrases.push('')"
            class="ml-2 mr-2"
            :disabled="isSaving"
          >
            Hinzufügen
          </BButton>
          <BButton
            variant="primary"
            @click="onSave"
            :disabled="isSaving"
          >
            Speichern
          </BButton>
        </template>
      </Contentbar>
    </template>
    <template #default>
      <h4 class="phrases__count">{{ phrases.length }} Phrasen insgesamt.</h4>
      <BListGroup class="phrases__list">
        <BListGroupItem
          v-for="(phrase, index) in phrases"
          :key="`phrase-${index}`"
          class="phrases__list-item"
        >
          <BTextarea
            v-model="phrases[index]"
          />
          <BButton
            @click="phrases.splice(index, 1)"
            variant="danger"
            class="ml-5"
          >
            X
          </BButton>
        </BListGroupItem>
      </BListGroup>
    </template>
  </Page>

</template>

<script>
import Page from '@/layout/components/Page.vue';
import Topbar from '@/layout/components/Topbar.vue';
import Contentbar from '@/layout/components/Contentbar.vue';

export default {
  name: 'PagePhrases',
  components: {
    Page,
    Topbar,
    Contentbar,
  },
  async created() {
    await this.$store.dispatch('loadPhrases');
    this.phrases = [...this.$store.state.phrases];
  },
  data() {
    return {
      isSaving: false,
      phrases: [],
    };
  },
  methods: {
    async onSave() {
      this.isSaving = true;
      await this.$store.dispatch('savePhrases', this.phrases);
      this.isSaving = false;
    },
  },
};
</script>

<style scoped>
  /deep/ .page__content {
    flex-direction: column;
  }

  .phrases__count {
    display: block;
    padding: 0.75rem 1.25rem;
    position: sticky;
    top: 0;
    background: white;
    z-index: 1;
  }

  .phrases__list {
    flex-direction: column-reverse;
    justify-content: flex-end;
  }

  .phrases__list-item {
    display: flex;
    align-items: flex-start;
  }
</style>
